import { useEffect } from 'react';
import { pushDataLayer, getUserData } from '../utils/dataLayer';

/**
 * Hook to initialize and push dataLayer event on page load
 * @param pathname - Current page pathname
 */
export const useDataLayer = (pathname: string): void => {
  useEffect(() => {
    const initializeDataLayer = async () => {
      // Get user data if available
      const userData = getUserData();
      
      // Push dataLayer event
      await pushDataLayer(pathname, userData);
    };

    initializeDataLayer();
  }, [pathname]);
};
